import React, {useState, useEffect, useRef} from 'react';
import {DebounceInput} from 'react-debounce-input';
import NumberFormat from 'react-number-format';

export default function Range({
    value,
    minBounds,
    maxBounds,
    onChangeComplete,
    thousandSeparator,
    decimalSeparator,
    name,
    filterName,
    prefix,
}) {
    const [rangeValue, setRangeValue] = useState({min: minBounds, max: maxBounds});
    const [validationMessage, setValidationMessage] = useState('');
    const minInputRef = useRef();
    const maxInputRef = useRef();

    useEffect(() => {
        if (value) setRangeValue(value);
    }, [value]);

    return (
        <>
            <div className="row align-items-center gutters-3">
                <>
                    <div className="col d-flex align-items-center">
                        {prefix && <span className="font-weight-medium text-muted--80 mr-4">{prefix}</span>}
                        {(rangeValue.min !== minBounds || rangeValue.max !== maxBounds) && (
                            <input type="hidden" name={name} value={`${rangeValue.min};${rangeValue.max !== null ? rangeValue.max : ''}`} />
                        )}
                        <NumberFormat
                            value={rangeValue.min}
                            displayType={'text'}
                            decimalSeparator={decimalSeparator}
                            thousandSeparator={thousandSeparator}
                            fixedDecimalScale={true}
                            decimalScale={0}
                            renderText={(formatValue) => (
                                <DebounceInput
                                    inputRef={minInputRef}
                                    onFocus={() => minInputRef.current.select()}
                                    debounceTimeout={1000}
                                    inputMode="numeric"
                                    type="text"
                                    className="form-control"
                                    value={formatValue}
                                    onChange={(event) => {
                                        if (event.target.value !== '' && event.target.value > value.max) {
                                            setValidationMessage(`De minimale waarde van "${filterName}" kan niet hoger zijn dan de maximale waarde.`);
                                            return;
                                        }

                                        setRangeValue({min: event.target.value, max: value.max});
                                        onChangeComplete({
                                            selected_min: event.target.value,
                                            selected_max: value.max,
                                        });

                                        setValidationMessage('');
                                    }}
                                />
                            )}
                        />
                    </div>
                    <div className="col-auto">
                        <span>tot</span>
                    </div>
                    <div className="col">
                        <NumberFormat
                            value={rangeValue.max}
                            displayType={'text'}
                            decimalSeparator={decimalSeparator}
                            thousandSeparator={thousandSeparator}
                            fixedDecimalScale={true}
                            decimalScale={0}
                            renderText={(formatValue) => (
                                <DebounceInput
                                    inputRef={maxInputRef}
                                    onFocus={() => maxInputRef.current.select()}
                                    debounceTimeout={1000}
                                    inputMode="numeric"
                                    type="text"
                                    className="form-control"
                                    value={formatValue}
                                    onChange={(event) => {
                                        if (event.target.value !== '' && event.target.value < value.min) {
                                            setValidationMessage(`De maximale waarde van "${filterName}" kan niet lager zijn dan de minimale waarde.`);
                                            return;
                                        }

                                        setRangeValue({min: value.min, max: event.target.value});
                                        onChangeComplete({
                                            selected_min: value.min,
                                            selected_max: event.target.value,
                                        });

                                        setValidationMessage('');
                                    }}
                                />
                            )}
                        />
                    </div>
                </>
            </div>
            {
                validationMessage !== '' &&
                <p className="mt-3 small text-danger">{validationMessage}</p>
            }
        </>
    );
}
